//import { fabric } from 'fabric-with-gestures';
import Hammer from 'hammerjs';
let curScale = false, curMove = false, ifOnClick = false, lastX = 0, lastY = 0, currentX = 0, currentY = 0, xChange = 0, yChange = 0, zoomStartScale, selectedItem;
let seatObj = {
  id: '',
  label: '',//编号
  name: '',//别名
  direction: 'bottom',//方向
  power: false,//电源
  computer: false,//电脑
  window: false,//靠窗
  lock: false,//禁用
  scene: false,//现场
  status: 'FULL'//状态
};
class seatPreview {
  // eslint-disable-next-line space-before-function-paren
  constructor() {
    this.minimap = null;
    this.design = null;
    this.imgDir = "../images/seat/";
    this.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  }

  dispose() {
    if (this.design != null) {
      this.design.clear();
      this.design.dispose();
      this.design = null;
      this.minimap.clear();
      this.minimap.dispose();
      this.minimap = null;
    }
  }

  render(canvasData, successCallback, clickCallback) {
    this.designWidth = 1320;
    this.designHeight = 1320 / 2;
    this.isPc = window.innerWidth > 992;

    this.dispose();

    //缩略图画布
    this.minimap = new fabric.Canvas('seatLayoutPreviewMiniMap', {
      width: 100,
      height: 50,
      containerClass: 'seatLayoutMiniMap',
      selection: false
    });

    //数据画布
    this.design = new fabric.Canvas('seatLayoutPreviewCanvas', {
      width: this.designWidth,
      height: this.designHeight,
      selection: false,
      devicePixelRatio: true,
      allowTouchScrolling: true,
      containerClass: 'seatLayoutCanvasContainer',
      hoverCursor: 'pointer'
    });
    this.design.setZoom(0.9);

    let parentNode = null;
    if (document.getElementById("seatLayoutPreviewCanvas")) {
      parentNode = document.getElementById("seatLayoutPreviewCanvas").parentNode;
    }
    if (parentNode) {
      this.viewWidth = Math.min(parentNode.offsetWidth, this.designWidth, window.innerWidth);
      this.viewHeight = Math.min(parentNode.offsetHeight, this.designHeight, window.innerHeight)
    }

    let that = this, design = that.design;
    if (!that.isTouch) {
      design.on('mouse:wheel', function (opt) {
        curScale = true;
        var delta = opt.e.deltaY;
        var zoom = design.getZoom();
        zoom *= 0.999 ** delta;
        if (zoom > 20) zoom = 20;
        if (zoom < 0.01) zoom = 0.01;
        design.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);

        var vpt = this.viewportTransform;
        let wz = design.getWidth() * (1 - zoom) - (design.getWidth() - that.viewWidth), hz = design.getHeight() * (1 - zoom) - (design.getHeight() - that.viewHeight);
        if (zoom < that.viewWidth / design.getWidth()) {
          vpt[4] = wz / 2;
        } else {
          if (vpt[4] >= 0) {
            vpt[4] = 0;
          } else if (vpt[4] < wz) {
            vpt[4] = wz;
          }
        }
        if (zoom < that.viewHeight / design.getHeight()) {
          vpt[5] = hz / 2;
        } else {
          if (vpt[5] >= 0) {
            vpt[5] = 0;
          } else if (vpt[5] < hz) {
            vpt[5] = hz;
          }
        }

        that.updateMiniMapVP();
        opt.e.preventDefault();
        opt.e.stopPropagation();
      })
      design.on('mouse:down', function (opt) {
        var evt = opt.e;
        this.isDragging = true;
        this.lastPosX = evt.clientX;
        this.lastPosY = evt.clientY;
        that.defaultClick();
        that.findTarget(evt);
      });
      design.on('mouse:move', function (opt) {
        if (this.isDragging) {
          var e = opt.e;
          var vpt = this.viewportTransform;

          var zoom = design.getZoom();
          let wz = design.getWidth() * (1 - zoom) - (design.getWidth() - that.viewWidth), hz = design.getHeight() * (1 - zoom) - (design.getHeight() - that.viewHeight);
          if (zoom < that.viewWidth / design.getWidth()) {
            vpt[4] = wz / 2;
          } else {
            vpt[4] += e.clientX - this.lastPosX;
            if (vpt[4] >= 0) {
              vpt[4] = 0;
            } else if (vpt[4] < wz) {
              vpt[4] = wz;
            }
          }
          if (zoom < that.viewHeight / design.getHeight()) {
            vpt[5] = hz / 2;
          } else {
            vpt[5] += e.clientY - this.lastPosY;
            if (vpt[5] >= 0) {
              vpt[5] = 0;
            } else if (vpt[5] < hz) {
              vpt[5] = hz;
            }
          }

          design.requestRenderAll();
          that.updateMiniMapVP();
          this.lastPosX = e.clientX;
          this.lastPosY = e.clientY;
          curMove = true;//当前在移动
        }
      })
      design.on('mouse:up', function (opt) {
        design.setViewportTransform(this.viewportTransform);
        this.isDragging = false;
        that.touchSelected(clickCallback);
      });

    } else {
      var hammer = new Hammer(design.upperCanvasEl);
      hammer.get('pinch').set({ enable: true });
      hammer.get('pan').set({ direction: Hammer.DIRECTION_ALL });

      hammer.on('pinchstart', function (event) {
        curScale = true;
        zoomStartScale = design.getZoom();
      });

      hammer.on('pinchmove', function (event) {
        let zoom = zoomStartScale * event.scale;
        if (zoom > 10) zoom = 10;
        if (zoom < 0.09) zoom = 0.09;
        let canvasRect = design.upperCanvasEl.getBoundingClientRect();
        let touchX = event.center.x - canvasRect.left;
        let touchY = event.center.y - canvasRect.top;
        design.zoomToPoint(new fabric.Point(touchX, touchY), zoom);

        var vpt = design.viewportTransform;
        //因为移动端是竖屏 必须要减去当前的宽才可以看到右侧隐藏的区域
        let wz = design.getWidth() * (1 - zoom) - (design.getWidth() - that.viewWidth),
          hz = design.getHeight() * (1 - zoom) - (design.getHeight() - that.viewHeight);
        if (zoom < that.viewWidth / design.getWidth()) {//因为移动端竖屏的关系 必须在他们的比例下才执行左侧固定
          vpt[4] = wz / 2;
        } else {
          if (vpt[4] >= 0) {
            vpt[4] = 0;
          } else if (vpt[4] < wz) {
            vpt[4] = wz;
          }
        }
        if (zoom < that.viewHeight / design.getHeight()) {
          vpt[5] = hz / 2;
        } else {
          if (vpt[5] >= 0) {
            vpt[5] = 0;
          } else if (vpt[5] < hz) {
            vpt[5] = hz;
          }
        }
        that.updateMiniMapVP();
      });


      hammer.on('panstart', function (event) {
        lastX = event.deltaX;
        lastY = event.deltaY;
      });

      hammer.on('panmove', function (event) {
        currentX = event.deltaX;
        currentY = event.deltaY;
        xChange = currentX - lastX;
        yChange = currentY - lastY;
        if (xChange * -1 >= 0.4 || yChange * -1 >= 0.4) {
          curMove = true;//当前在移动
        }
        var vpt = design.viewportTransform;
        var zoom = design.getZoom();
        let wz = design.getWidth() * (1 - zoom) - (design.getWidth() - that.viewWidth),
          hz = design.getHeight() * (1 - zoom) - (design.getHeight() - that.viewHeight);
        if (zoom < that.viewWidth / design.getWidth()) {
          vpt[4] = wz / 2;
        } else {
          vpt[4] += xChange;
          if (vpt[4] >= 0) {
            vpt[4] = 0;
          } else if (vpt[4] < wz) {
            vpt[4] = wz;
          }
        }
        if (zoom < that.viewHeight / design.getHeight()) {
          vpt[5] = hz / 2;
        } else {
          vpt[5] += yChange;
          if (vpt[5] >= 0) {
            vpt[5] = 0;
          } else if (vpt[5] < hz) {
            vpt[5] = hz;
          }
        }
        design.requestRenderAll();
        that.updateMiniMapVP();
        lastX = event.deltaX;
        lastY = event.deltaY;
      });

      //单击
      hammer.on('tap', function (event) {
        that.defaultClick();
        that.findTarget(event.srcEvent);
        that.touchSelected(clickCallback);
      });

    }


    //自定义座位画布元素
    fabric.LabeledImage = fabric.util.createClass(fabric.Image, {
      type: 'labeledImage',
      initialize: function (element, options) {
        options || (options = {});
        this.callSuper('initialize', element, options);
        this.set('seat', options.seat || {});
      },

      toObject: function () {
        return fabric.util.object.extend(this.callSuper('toObject'), {
          seat: this.get('seat')
        });
      },
      _set: function (key, value) {
        this[key] = value;
      },
      _render: function (ctx) {
        this.callSuper('_render', ctx);
        let seat = this.seat;
        ctx.font = '20px Arial';
        ctx.fillStyle = seat.scene ? '#FFFF00' : '#fff';
        var textWidth = ctx.measureText(seat.label).width;
        if (seat.direction == "top") {
            ctx.fillText(seat.label, -textWidth / 2, 18);
        } else if (seat.direction == "left") {
            ctx.fillText(seat.label, 13 - textWidth / 2, 5);
        } else if (seat.direction == "right") {
            ctx.fillText(seat.label, -13 - textWidth / 2, 5);
        } else {
            ctx.fillText(seat.label, -textWidth / 2, -7);
        }
    }
    });
    //反序列化座位画布元素使用
    fabric.LabeledImage.fromObject = function (_object, callback) {
      let object = fabric.util.object.clone(_object);
      fabric.util.loadImage(object.src, function (img, isError) {
        if (isError) {
          callback && callback(null, true);
          return;
        }
        fabric.LabeledImage.prototype._initFilters.call(object, object.filters, function (filters) {
          object.filters = filters || [];
          fabric.LabeledImage.prototype._initFilters.call(object, [object.resizeFilter], function (resizeFilters) {
            object.resizeFilter = resizeFilters[0];
            fabric.util.enlivenObjects([object.clipPath], function (enlivedProps) {
              object.clipPath = enlivedProps[0];
              callback(new fabric.LabeledImage(img, object), false);
            });
          });
        });
      }, null, object.crossOrigin);
    };

    /**
     * 正式加载有效数据 触发渲染和激活缩略图
     */
    setTimeout(function () {
      fabric.Object.prototype.selectable = false;
      if (!canvasData) {
        canvasData = "{}";
      }
      if (typeof canvasData === 'string') {
        canvasData = JSON.parse(canvasData);
      }

      if (that.isEmptyObject(canvasData)) {//判断对象是否为空
        that.defaultBg();
        that.initMinimap();
        that.updateMiniMapVP();
        return;
      }
      if (canvasData.objects) {//这个是画布所有的元素数组
        for (let i = 0; i < canvasData.objects.length; i++) {
          let item = canvasData.objects[i];
          if (item.type == "labeledImage") {
            item.seat.status = 'FULL'
            if (!item.src || item.src == "") {
              item.src = that.getPathSrc(Object.assign({}, seatObj, item.seat));
            }
          }
        }
      }

      //这个是画布正式加载渲染json数据
      that.design.loadFromJSON(canvasData, function () {//渲染成功之后的回调
        design.getObjects().forEach(function (obj) {
          if (obj.type === 'group') {
            obj.toActiveSelection();
          } else if (obj.type == "rect" && obj.left == 0 && obj.top == 0) {
            obj.set({ evented: false });
          }
        })

        that.initMinimap();//初始化缩略图画布
        that.updateMiniMapVP();//改变
        successCallback && successCallback();
      });
    }, 50);
  }

  //更新座位数据
  reRender(freeSeatObj) {
    let that = this;
    let objects = that.design.getObjects()
    if (objects && !that.isEmptyObject(freeSeatObj)) {//这个是画布所有的元素数组
      for (let i = 0; i < objects.length; i++) {
        let item = objects[i];
        if (item.type == "labeledImage" && freeSeatObj[item.seat.id]) {
          let seat = Object.assign({}, seatObj, item.seat, freeSeatObj[item.seat.id])
          item.set({ seat: seat });
          item.setSrc(this.getPathSrc(seat), () => {
            that.design.requestRenderAll()
          })
        }
      }
      setTimeout(() => {
        that.updateMiniMap()
      }, 100)
    }
  }

  findTarget(e) {
    let that = this, design = that.design;
    let objects = design.getObjects();
    if (objects && objects.length > 0) {
      let pointer = design.getPointer(e);
      for (let i = 0; i < objects.length; i++) {
        let object = objects[i];
        if (object.type == "labeledImage" && object.containsPoint(pointer, null, true)) {
          selectedItem = object;
          break;
        }
      }
    }
  }

  touchSelected(callback) {
    let that = this;
    if (!ifOnClick) {
      ifOnClick = true;
      if (selectedItem && that.isClick()) {
        console.info(JSON.stringify(selectedItem.seat));
        callback && callback(selectedItem.seat);
      }
      selectedItem = null;
      setTimeout(() => {
        ifOnClick = false;
      }, 50)
    }
  }
  defaultClick() {
    curScale = false;
    curMove = false;
  }
  isClick() {
    return !curScale && !curMove;
  }
  defaultBg() {
    let that = this, design = that.design;
    design.setBackgroundImage(new fabric.Rect({
      width: design.getWidth(),
      height: design.getHeight(),
      fill: '#e9eef3'
    }), design.renderAll.bind(design));
  }
  /**
   * 构建座位数据生成对应的图标名 根据上面的相对位置加载图标
   * @param {座位数据} seat
   * @returns
   */
  getPathSrc(seat) {
    let pathSrc = '';
    if (seat.lock) {
      pathSrc += "disable";
    } else if (seat.status == "BOOKED" || seat.status == "IN_USE" || seat.status == "FULL") {//预约中 使用中
      pathSrc += "book";
    } else {
      pathSrc += (seat.status).toLowerCase();//空闲 离开
    }
    if (seat.window) {
      pathSrc += "-window";
    }
    if (seat.power && !seat.computer) {
      pathSrc += "-power";
    }
    if (seat.computer) {
      pathSrc += "-computer";
    }
    pathSrc += "-" + seat.direction + ".png";
    return require(`@/assets/images/seat-images/seat/${pathSrc}`)
  }

  /**
   * 根据画布的变化 实时修改缩略图显示
   */
  updateMiniMap() {
    let that = this, minimap = that.minimap;
    minimap.backgroundImage._element = that.createCanvasEl();
    minimap.requestRenderAll();
  }
  /**
   * 根据画布的变化 实时缩放缩略图
   */
  updateMiniMapVP() {
    let that = this, design = that.design, minimap = that.minimap;
    var designSize = { width: design.getWidth(), height: design.getHeight() };
    var rect = minimap.getObjects()[0];
    var designRatio = fabric.util.findScaleToFit(designSize, design);
    var totalRatio = fabric.util.findScaleToFit(designSize, minimap);
    var finalRatio = designRatio / design.getZoom();
    rect.scaleX = finalRatio;
    rect.scaleY = finalRatio;
    rect.top = minimap.backgroundImage.top - design.viewportTransform[5] * totalRatio / design.getZoom();
    rect.left = minimap.backgroundImage.left - design.viewportTransform[4] * totalRatio / design.getZoom();
    minimap.requestRenderAll();
  }
  //初始化缩略图
  initMinimap() {
    let that = this, design = that.design, minimap = that.minimap, isPc = that.isPc;
    var backgroundImage = new fabric.Image(that.createCanvasEl());
    backgroundImage.scaleX = 1 / design.getRetinaScaling();
    backgroundImage.scaleY = 1 / design.getRetinaScaling();
    minimap.centerObject(backgroundImage);
    minimap.backgroundColor = 'white';
    minimap.backgroundImage = backgroundImage;
    minimap.requestRenderAll();
    var minimapView = new fabric.Rect({
      top: backgroundImage.top,
      left: backgroundImage.left,
      width: isPc ? backgroundImage.width / design.getRetinaScaling() : (backgroundImage.height / 2 / design.getRetinaScaling() + 5),
      height: backgroundImage.height / design.getRetinaScaling(),
      fill: 'rgba(0, 0, 255, 0.3)',
      cornerSize: 6,
      transparentCorners: false,
      cornerColor: 'blue',
      strokeWidth: 0,
    });
    minimapView.controls = {
      br: fabric.Object.prototype.controls.br,
    };
    minimap.add(minimapView);
  }
  /**
  * 创建缩略图
  * @returns
  */
  createCanvasEl() {
    let that = this, design = that.design, minimap = that.minimap;
    var designSize = { width: design.getWidth(), height: design.getHeight() };
    var originalVPT = design.viewportTransform;
    var designRatio = fabric.util.findScaleToFit(designSize, design);
    var minimapRatio = fabric.util.findScaleToFit(design, minimap);
    var scaling = minimap.getRetinaScaling();
    var finalWidth = designSize.width * designRatio;
    var finalHeight = designSize.height * designRatio;
    design.viewportTransform = [
      designRatio, 0, 0, designRatio,
      (design.getWidth() - finalWidth) / 2,
      (design.getHeight() - finalHeight) / 2
    ];
    var ca = design.toCanvasElement(minimapRatio * scaling);
    design.viewportTransform = originalVPT;
    return ca;
  }
  isEmptyObject(e) {
    var t;
    for (t in e)
      return !1;
    return !0;
  }
}
//对外暴露的接口
export default seatPreview



// WEBPACK FOOTER //
// ./src/lib/seatPreview.js